import React, { useEffect } from "react";
import homeImage from "../assets/Product quality-pana 1.png";
import WhoWeAre from "../whoWeAre/whoWeAre";
import Plans from "../Plans/SurveyAtGlance";
import ContactForm from "../Form/Form";
import FAQ from "../FAQS/faqs";
import Testimonials from "../Testimonial/Testimonial";
import PricingPlans from "../Plans/Plan";
import { scrollToSection } from "../utils/ScrollToSection";
import HowItWorks from "../HowItWork/HowItWorks";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaYoutube,
  FaInstagram,
  FaWhatsapp,
} from "react-icons/fa";
// import HowItWorks from "../HowItWorks/howItWorks";

const Home = () => {
  useEffect(() => {
    const sectionId = localStorage.getItem("scrollTo");
    if (sectionId) {
      scrollToSection(sectionId);
      localStorage.removeItem("scrollTo");
    }
  }, []);

  return (
    <section className="bg-mint-glass h-auto">
      <div
        id="Home"
        className="flex flex-col md:gap-[45px] mx-auto max-w-90vw md:flex-row "
      >
        <div className="flex flex-col mx-auto gap-5 p-2 sm:p-0 max-w-[670px] pt-[50px] sm:pt-[100px]">
          <h1 className="font-sans font-bold text-[40px]  sm:text-[50px] leading-[61px]">
            Turn Opinions into Earnings – Instantly with SurveysIQ !
          </h1>
          <p className="font-sans font-normal text-xl">
            Share your opinion and earn real cash - anytime, anywhere. SurveysIQ
            makes it easy to turn your thoughts into instant rewards.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="https://play.google.com/store/apps/details?id=com.techaircraft.surveyiq&pcampaignid=web_share">
              <button className="bg-green-600 hover:bg-green-700 active:bg-green-800 focus:ring-4 focus:ring-green-300 transition duration-200 ease-in-out transform hover:scale-105 p-2 px-4 font-sans max-w-[204px] rounded-lg text-white shadow-md">
                Download for Android
              </button>
            </Link>
            <Link to="https://surveysiq.com/ ">
              <button className="bg-green-600 hover:bg-green-700 active:bg-green-800 focus:ring-4 focus:ring-green-300 transition duration-200 ease-in-out transform hover:scale-105 p-2 px-4 font-sans max-w-[204px] rounded-lg text-white shadow-md">
                Download for IOS
              </button>
            </Link>
          </div>
          <div className="flex flex-col items-start space-y-2">
            <div className="flex flex-wrap gap-4 text-gray-400 text-xl">
              <a href="https://www.facebook.com/Surveysiq">
                <FaFacebookF className="hover:text-blue-400" />
              </a>
              {/* <a href="#">
                <FaTwitter className="hover:text-blue-300" />
              </a>
              <a href="#">
                <FaTelegram className="hover:text-blue-500" />
              </a> */}
              <a href="https://www.youtube.com/@surveysiq">
                <FaYoutube className="hover:text-red-600" />
              </a>
              <a href="https://www.instagram.com/surveysiqs/">
                <FaInstagram className="hover:text-pink-500" />
              </a>
              {/* <a href="#">
                <FaGooglePlusG className="hover:text-red-400" />
              </a>
              <a href="#">
                <FaPinterestP className="hover:text-red-500" />
              </a> */}
              <a href="https://api.whatsapp.com/send/?phone=917219770092&text">
                <FaWhatsapp className="hover:text-gray-400" />
              </a>
            </div>
          </div>
        </div>
        <div>
          <img src={homeImage} alt="" />
        </div>
      </div>

      <div id="who-we-are">
        <WhoWeAre />
      </div>
      <div id="Plans">
        <Plans />
      </div>
      <div id="how-It-works">
        <HowItWorks />
      </div>
      <div>
        <PricingPlans />
      </div>
      <div id="faq">
        <FAQ />
      </div>
      <div id="Testimonials">
        <Testimonials />
      </div>
      <div id="form">
        <ContactForm />
      </div>
    </section>
  );
};

export default Home;
